export const TAX_PAYER_SUSPENDED = "tax_payer_suspended";

export interface TaxPayerSuspensionSummary {
  reasonCode?: string;
  reasonName?: string;
  message: string;
  suspendedAt?: string;
}

interface TaxPayer {
  id?: number;
  ruc?: string;
  socialName?: string;
  fantasyName?: string;
  type?: string;
  regimeTypeId?: number;
  isDemo?: boolean;
  whatsappEnabled?: boolean;
  uniqueId?: string | null;
  /** Present while the company is suspended. */
  suspension?: TaxPayerSuspensionSummary;
  /** True when the suspension keeps the current user out. */
  accessBlocked?: boolean;
}

export const TAX_PAYER_TYPE_PERSON = "person";
export const TAX_PAYER_TYPE_ENTITY = "entity";
export const TAX_PAYER_TYPE_PERSON_LABEL = "Persona";
export const TAX_PAYER_TYPE_ENTITY_LABEL = "Entidad";

export const TAX_PAYER_TYPE_CHOICES: Map<string, string> = new Map([
  [TAX_PAYER_TYPE_PERSON, TAX_PAYER_TYPE_PERSON_LABEL],
  [TAX_PAYER_TYPE_ENTITY, TAX_PAYER_TYPE_ENTITY_LABEL],
]);

export const newTaxPayer = (): TaxPayer => {
  return {};
};

export default TaxPayer;
